
export default function KaysvilleTestimonial() {
  return (
    <section className="py-12 md:py-20 bg-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-8 md:mb-12">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 mb-3 md:mb-4">
            What Kaysville Residents Say
          </h2>
        </div>

        <div className="bg-gradient-to-br from-sky-50 to-blue-50 rounded-xl md:rounded-2xl p-6 md:p-10 shadow-lg">
          <div className="flex items-center gap-1 md:gap-2 mb-4 md:mb-6">
            {[...Array(5)].map((_, i) => (
              <i key={i} className="ri-star-fill text-xl md:text-2xl text-yellow-400"></i>
            ))}
          </div>
          <p className="text-base md:text-xl text-gray-700 leading-relaxed mb-6 md:mb-8 italic">
            "Our basement flooded during a winter storm and we called Davis County Disaster Cleanup at 2 AM. They arrived at our Kaysville home within 45 minutes! The team was professional, efficient, and had all the water extracted by morning. They explained every step of the water damage restoration process and worked with our insurance company. Living near Barnes Park, we needed someone reliable and fast - Davis County Disaster Cleanup exceeded our expectations. Our Kaysville home is completely restored and we couldn't be happier with their emergency flood cleanup service."
          </p>
          <div className="flex items-center gap-3 md:gap-4">
            <div className="w-12 h-12 md:w-16 md:h-16 bg-sky-600 rounded-full flex items-center justify-center flex-shrink-0">
              <span className="text-white text-lg md:text-2xl font-bold">JM</span>
            </div>
            <div>
              <div className="font-bold text-gray-900 text-base md:text-lg">Jennifer Martinez</div>
              <div className="text-sm md:text-base text-gray-600">Barnes Park Area</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
